import { sanitizeFetchType } from 'react-admin'
import { PassageDirections } from '../../enum/PassageDirections'
import { ResourceName } from '../../ResourceName'
import {
  ToggleButtonAction,
  ToggleButtonState,
  ToggleType,
} from './passage-set-boolean-status-button'
import { SetOpenRequest } from './passages.provider'

type Mutation = {
  type: string
  resource: string
  // eslint-disable-next-line @typescript-eslint/ban-types
  payload?: object
}

const setOpenBackwardsMutation = (
  { passageId, timeInSeconds }: SetOpenRequest,
  auditNote?: string,
  recurringJobName?: string,
  cronExpression?: string,
): Mutation => ({
  type: sanitizeFetchType('setOpen'),
  resource: ResourceName.PASSAGES,
  payload: {
    passageId,
    timeInSeconds,
    direction: PassageDirections.OUT,
    auditComment: auditNote,
    recurringJobName,
    cronExpression,
  },
})

const setOpenForwardMutation = (
  { passageId, timeInSeconds }: SetOpenRequest,
  auditNote?: string,
  recurringJobName?: string,
  cronExpression?: string,
): Mutation => ({
  type: sanitizeFetchType('setOpen'),
  resource: ResourceName.PASSAGES,
  payload: {
    passageId,
    timeInSeconds,
    direction: PassageDirections.IN,
    auditComment: auditNote,
    recurringJobName,
    cronExpression,
  },
})

type State = {
  mutateQuery?: (
    passage: SetOpenRequest,
    auditNote?: string,
    recurringJobName?: string,
    cronExpression?: string,
  ) => Mutation
} & ToggleButtonState

export const passageSetOpenButtonInitialState = {
  type: ToggleType.OFF,
  text: 'resources.passages.actions.setOpen.setBackwards',
}

export const passageSetOpenButtonReducer = (
  state: State,
  { type }: ToggleButtonAction,
): State => {
  switch (type) {
    case ToggleType.OFF: {
      return {
        type,
        text: 'resources.passages.actions.setOpen.setBackwards',
        mutateQuery: setOpenBackwardsMutation,
      }
    }
    case ToggleType.ON: {
      return {
        type,
        text: 'resources.passages.actions.setOpen.setForward',
        mutateQuery: setOpenForwardMutation,
      }
    }
    default:
      throw new Error()
  }
}
